import en from "./locales/en/";
import es from "./locales/es/";
import de from "./locales/de/";

export default {
  en,
  es,
  de
};
